import React from 'react'
import styles from './Timeline.module.scss'
import { COUNTRY } from '../../../../common/utils/constants'

const isRu = COUNTRY === 'ru'

const steps = [
  {
    id: 1,
    title: 'Сайт + приложение',
    description: 'витрина под ключ',
    days: '2–7 дней',
    status: 'done',
  },
  { id: 2, title: 'Приём заказов', description: 'онлайн и офлайн', status: 'done' },
  ...(isRu
    ? [
        {
          id: 3,
          title: 'Оплаты (СБП + карты)',
          description: 'Комиссия от 0.7%',
          status: 'current',
        },
        { id: 6, title: 'Касса + ОФД', description: 'печать чеков', status: 'next' },
      ]
    : []),
  { id: 4, title: 'Склад и остатки', description: 'учёт товаров', status: 'done' },
  { id: 5, title: 'Персонал и мотивация', description: 'KPI, бонусы, роли', status: 'done' },
]

export const Timeline: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.line} />

      {steps.map((step, index) => (
        <div key={step.id} className={styles.step}>
          <div className={`${styles.node} ${styles[step.status]}`}>
            <span className={styles.nodeNumber}>{index + 1}</span>
          </div>
          <div className={styles.content}>
            <h4 className={styles.title}>{step.title}</h4>
            <p className={styles.description}>{step.description}</p>
            <span className={styles.days}>{step.days}</span>
          </div>
        </div>
      ))}
    </div>
  )
}
